"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Loader } from "lucide-react";
function InquiryForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="p-8 bg-background/5 border border-background/10 rounded-xl text-center backdrop-blur-sm">
                <h3 className="text-2xl md:text-3xl font-default font-semibold text-background mb-4">
                    Inquiry Received
                </h3>
                <p className="text-background/80 mb-8 max-w-md mx-auto">
                    {successMessage}
                </p>
                <Button onClick={resetForm} variant="outline" className="bg-transparent text-background border-background/30 hover:bg-background/10 hover:text-background">
                    Submit Another Inquiry
                </Button>
            </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <FormField control={control} name="name" rules={{
        required: "Name is required"
      }} render={({
        field
      }) => <FormItem>
                            <FormLabel className="text-background/90">Full Name</FormLabel>
                            <FormControl>
                                <Input placeholder="Jane Doe" className="bg-background text-foreground border-transparent focus-visible:ring-primary shadow-sm" {...field} />
                            </FormControl>
                            <FormMessage className="text-red-400" />
                        </FormItem>} />
                <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Please enter a valid email address"
        }
      }} render={({
        field
      }) => <FormItem>
                            <FormLabel className="text-background/90">Email Address</FormLabel>
                            <FormControl>
                                <Input type="email" placeholder="jane@example.com" className="bg-background text-foreground border-transparent focus-visible:ring-primary shadow-sm" {...field} />
                            </FormControl>
                            <FormMessage className="text-red-400" />
                        </FormItem>} />
            </div>

            <FormField control={control} name="phone" render={({
      field
    }) => <FormItem>
                        <FormLabel className="text-background/90">Phone Number (Optional)</FormLabel>
                        <FormControl>
                            <Input type="tel" placeholder="(555) 123-4567" className="bg-background text-foreground border-transparent focus-visible:ring-primary shadow-sm" {...field} />
                        </FormControl>
                        <FormMessage className="text-red-400" />
                    </FormItem>} />

            <FormField control={control} name="message" rules={{
      required: "Please tell us about your program interest"
    }} render={({
      field
    }) => <FormItem>
                        <FormLabel className="text-background/90">Program Interest & Message</FormLabel>
                        <FormControl>
                            <Textarea placeholder="I am interested in learning more about..." className="min-h-[160px] bg-background text-foreground border-transparent focus-visible:ring-primary shadow-sm resize-y" {...field} />
                        </FormControl>
                        <FormMessage className="text-red-400" />
                    </FormItem>} />

            {submitError && <div className="p-4 bg-red-500/10 border border-red-500/20 rounded-lg">
                    <p className="text-red-400 text-sm font-medium">{submitError}</p>
                </div>}

            <div className="pt-2 text-center">
                <Button type="submit" disabled={isSubmitting} size="lg" className="w-full md:w-auto min-w-[200px] bg-primary hover:bg-primary/90 text-primary-foreground shadow-md">
                    {isSubmitting ? <>
                            <Loader className="animate-spin mr-2 size-5" />
                            Submitting...
                        </> : 'Submit Inquiry'}
                </Button>
            </div>
        </Form>;
}
export default function RequestMoreInformation() {
  return <section id="request-more-information" className="bg-foreground py-20 md:py-32 relative overflow-hidden">
            {}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-10">
                <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-lg bg-primary blur-[120px]" />
                <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-primary blur-[120px]" />
            </div>

            <div className="container mx-auto px-4 relative z-10">
                <div className="max-w-3xl mx-auto">
                    <div className="text-center mb-12 md:mb-16">
                        <h2 className="text-3xl md:text-5xl font-default font-bold text-background mb-6 tracking-tight">
                            Request More Information
                        </h2>
                        <p className="text-lg text-background/80 max-w-2xl mx-auto">
                            Take the first step towards your transformation. Fill out the form below and our team will get back to you with details about our programs.
                        </p>
                    </div>

                    <div className="bg-background/5 p-6 md:p-10 rounded-2xl border border-background/10 shadow-2xl backdrop-blur-sm">
                        <FormProvider formId="begin-your-transformation-form" sectionName="request-more-information" defaultValues={{
            name: "",
            email: "",
            phone: "",
            message: ""
          }} validationRules={{
            name: {
              required: true
            },
            email: {
              required: true,
              pattern: "email"
            },
            message: {
              required: true
            }
          }} submitText="Submit Inquiry" successMessage="Thank you for your interest! We have received your inquiry and will contact you shortly.">
                            <InquiryForm />
                        </FormProvider>
                    </div>
                </div>
            </div>
        </section>;
}